<ng-template [carsFragmentHost]="content.children" [readOnly]="readOnly"></ng-template>
<span
  *ngIf="!content.length()"
  [class.focused]="focused"
  [class.schedule-list]="isInScheduleList()"
  contenteditable="false"
  >{{ content.displayPlaceholder }}</span
>
